import bucketApi from '@/api/bucketApi';
import receiptApi from '@/api/receiptApi';
import ActionButton from '@/components/actions/actionButton';
import RenderLoading from '@/components/renderLoading';
import { useHandleError } from '@/lib/errors';
import ReceiptListEntry from '@/pages/listView/components/receiptListEntry';
import { Checkbox, Container, Group, Modal, Stack } from '@mantine/core';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { t } from 'translations';

export const Route = createFileRoute('/_auth/_home/t/$tripId/add-receipt')({
    component: RouteComponent,
});

function RouteComponent() {
    const { tripId } = Route.useParams();
    const navigate = useNavigate();

    const [buckets, error] = bucketApi
        .list({
            type: 'standalone',
            mine: true,
            workflowState: ['draft', 'approval'],
        })
        .useCache();
    useHandleError(error);

    const [selected, setSelected] = useState(new Set<string>());

    function toggle(receiptId: string) {
        setSelected((selected) => {
            const newSet = new Set(selected);
            if (newSet.has(receiptId)) newSet.delete(receiptId);
            else newSet.add(receiptId);
            return newSet;
        });
    }

    async function save() {
        await receiptApi.addTripBatch([...selected], tripId);
        close();
    }

    function close() {
        navigate({ to: '/t/$tripId', params: { tripId }, replace: true });
    }

    return (
        <Modal opened onClose={close} centered title={t('tripEditor.selectReceipts')}>
            {!buckets ? (
                <RenderLoading center grow />
            ) : (
                <Container size="md">
                    <Stack gap="md">
                        {buckets.map((bucket) => (
                            <Group key={bucket.id} gap="md" align="center">
                                <ReceiptListEntry
                                    receipt={bucket.receipts[0]}
                                    bucket={bucket}
                                    onClick={() => toggle(bucket.receipts[0].id)}
                                />

                                <Checkbox
                                    checked={selected.has(bucket.receipts[0].id)}
                                    onChange={() => toggle(bucket.receipts[0].id)}
                                />
                            </Group>
                        ))}

                        <ActionButton
                            onClick={save}
                            disabled={selected.size === 0}
                            css={{ justifySelf: 'center' }}
                        >
                            {t('tripEditor.addSelectedReceipts')}
                        </ActionButton>
                    </Stack>
                </Container>
            )}
        </Modal>
    );
}
